import { Link } from 'react-router-dom';
import { categories } from '@/utils/articles';

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-secondary-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-alarm-warning-fill text-lg"></i>
              </span>
              <span className="text-lg font-black text-foreground-950">91黑料网</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              聚焦最新娱乐黑料、明星爆料与社会热点，24小时滚动更新，为关注真相的你提供第一手爆料资讯。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">
              <a href="#nav-category">内容分类</a>
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-foreground-600">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="cursor-pointer transition-colors hover:text-primary-600"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/hot" className="cursor-pointer transition-colors hover:text-primary-600">
                  热门爆料排行
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">
              <a href="#nav-about">关于与帮助</a>
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-foreground-600">
              <li>
                <Link to="/about" className="cursor-pointer transition-colors hover:text-primary-600">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer transition-colors hover:text-primary-600">
                  免责声明
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer transition-colors hover:text-primary-600">
                  联系方式
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer transition-colors hover:text-primary-600">
                  用户须知
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">
              <a href="#nav-contact">联络我们</a>
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                爆料邮箱：tip@91heiliao.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-500"></i>
                合作咨询：press@91heiliao.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500"></i>
                内容更新时间：每日 07:00 - 24:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-300 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 91黑料网 · 本站内容均为模拟演示数据，仅供产品展示使用
          </p>
          <p className="text-center text-xs text-foreground-500 sm:text-right">
            本站不提供任何违法信息，如有内容异议请通过邮箱联系我们
          </p>
        </div>
      </div>
    </footer>
  );
}